<div
  *ngIf="
    studentSortFilters.sortColumns && studentSortFilters.sortColumns.length > 0
  "
>
  <p class="title">Sorted By</p>
  <ul>
    <li *ngFor="let sortCol of studentSortFilters.sortColumns">
      {{ getColName(sortCol.student_kpi_id)
      }}<!--
   --><span
        *ngIf="
          getColName(sortCol.student_kpi_id) != metricRemovedFromDashboardText
        "
        >:
        {{ sortCol["sort_ascending"] ? "ASC" : "DESC" }}
      </span>
    </li>
  </ul>
</div>
<div
  *ngIf="
    studentSortFilters.filterColumns &&
    studentSortFilters.filterColumns.length > 0
  "
>
  <p class="title" *ngIf="!isGroupCriteria">Filtered By</p>
  <ul>
    <li *ngFor="let filterCol of studentSortFilters.filterColumns">
      {{ getColName(filterCol.student_kpi_id)
      }}<!--
   --><span
        *ngIf="
          getColName(filterCol.student_kpi_id) != metricRemovedFromDashboardText
        "
        >:
        <criteria-display-text
          [column]="currentCol"
          [criteria]="filterCol"
        ></criteria-display-text>
        <img
          [src]="'../../assets/images/views_trash.svg'"
          class="delete-img"
          (click)="clickedDelete.emit(filterCol.student_kpi_id)"
          alt="Delete"
          *ngIf="showDeleteBtn"
        />
      </span>
    </li>
  </ul>
</div>
